/* cords2-pdp-detail.js - the detail band's stage, 27 October 2026.

   THE ROW IN VIEW is the row that crosses one fixed line: the middle of the
   stage where it rests, sticky under the masthead. An IntersectionObserver
   watches that line (a rootMargin that leaves a one pixel band), so nothing
   runs on scroll and the browser reports a crossing once, the way the
   scrollytelling libraries do it (Scrollama). The line is measured from the
   stage's resting position, not its live position, so it does not move while
   the stage is still travelling up to stick, and it is measured again on
   resize.

   SMOOTHER, 27 October 2026, after Viktor found the band "a bit strange with
   the scroll and change":
   - Hovering a row no longer changes the picture. With the pointer resting
     over the list while scrolling, rows passing under it fired hover and
     fought the scroll, so the picture jumped back and forth.
   - The new picture fades in over the old one, which stays put underneath
     until the fade is done. Before, both faded at once and the field showed
     through halfway.
   - The text of the row in view is ink; the others are grey (cords2-pdp
     -detail.css), so it is clear which words belong to the picture.
   - The stage pictures are fetched when the band comes near, so a picture is
     ready before its row arrives.
   The scroll itself is never touched: no snapping, no smooth scrolling, no
   speed changes.

   Without IntersectionObserver the old measure-on-scroll runs instead. On a
   phone the stage is not shown and nothing is observed.
   See sections/cords2-pdp-detail.liquid. */
(function () {
  var FADE = 460;
  function init(root) {
    if (root.__c2detail) return;
    root.__c2detail = true;
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-c2-detail-row]'));
    var frames = Array.prototype.slice.call(root.querySelectorAll('[data-c2-detail-frame]'));
    var col = root.querySelector('.c2-detail__stagecol');
    var stage = root.querySelector('.c2-detail__stage');
    var count = root.querySelector('[data-c2-detail-n]');
    if (!rows.length || !frames.length || !col || !stage) return;
    var cur = -1, timer = 0, io = null, near = null;

    function set(i) {
      if (i < 0 || i >= rows.length || i === cur) return;
      var prev = cur;
      cur = i;
      rows.forEach(function (r, k) {
        r.classList.toggle('is-on', k === i);
        if (k === i) r.setAttribute('aria-current', 'step'); else r.removeAttribute('aria-current');
      });
      frames.forEach(function (f, k) {
        f.classList.remove('is-prev');
        f.classList.toggle('is-on', k === i);
        if (k === i) f.removeAttribute('aria-hidden'); else f.setAttribute('aria-hidden', 'true');
      });
      if (prev >= 0 && frames[prev]) frames[prev].classList.add('is-prev');
      clearTimeout(timer);
      timer = setTimeout(function () {
        frames.forEach(function (f) { f.classList.remove('is-prev'); });
      }, FADE + 40);
      if (count) count.textContent = (i < 9 ? '0' : '') + (i + 1);
    }

    /* the resting line: the sticky top plus half the stage */
    function line() {
      var top = parseFloat(window.getComputedStyle(col).top) || 0;
      return Math.round(top + stage.offsetHeight / 2);
    }

    /* fallback: the row whose top is at or above the line */
    function measure() {
      if (!col.offsetHeight) return;
      var y = line(), i = 0;
      for (var k = 0; k < rows.length; k++) { if (rows[k].getBoundingClientRect().top <= y) i = k; }
      set(i);
    }

    function observe() {
      if (io) { io.disconnect(); io = null; }
      if (!col.offsetHeight) return; /* phone: the stage is not shown */
      var y = line(), vh = window.innerHeight || document.documentElement.clientHeight;
      if (y <= 0 || y >= vh) { measure(); return; }
      io = new IntersectionObserver(function (entries) {
        var hit = -1;
        entries.forEach(function (e) { if (e.isIntersecting) hit = Math.max(hit, rows.indexOf(e.target)); });
        if (hit >= 0) set(hit);
      }, { rootMargin: (-y) + 'px 0px ' + (-(vh - y - 1)) + 'px 0px', threshold: 0 });
      rows.forEach(function (r) { io.observe(r); });
    }

    function preload() {
      frames.forEach(function (f) {
        var img = f.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }

    set(0);
    if ('IntersectionObserver' in window) {
      near = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { preload(); near.disconnect(); }
      }, { rootMargin: '100% 0px 100% 0px' });
      near.observe(root);
      observe();
      measure();
      var rt = 0;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { observe(); measure(); }, 150);
      });
    } else {
      var queued = false;
      var queue = function () { if (!queued) { queued = true; window.requestAnimationFrame(function () { queued = false; measure(); }); } };
      measure();
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
    }

    root.addEventListener('shopify:block:select', function (e) {
      var k = rows.indexOf(e.target.closest('[data-c2-detail-row]'));
      if (k >= 0) set(k);
    });
  }
  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-c2-detail]'), init);
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', function () { boot(); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
